﻿import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { LocalService } from "../../../core";

@Component({
  selector: "app-leaderboard-challenge-table",
  templateUrl: "./leaderboard-challenge-table.component.html",
  styleUrls: ["./leaderboard-challenge-table.component.scss"],
})
export class LeaderboardChallengeTableComponent
  implements OnInit, OnChanges, OnDestroy {
  entries: any = [];
  leaderboardType!: string;
  userProfile: any;
  size = 5;
  isManager: boolean = false;
  activityLeaderboardData: any;
  prodBookingData: any;
  pamData: any;
  begeoid: any;

  @Input() optOut: any;
  @Input() set leaderboardData(leaderboardData: any) {
    this.userProfile = LocalService.get("userProfile");
    if (leaderboardData) {
      this.activityLeaderboardData = leaderboardData;
      this.prodBookingData = [];
      this.entries = [];

      if (leaderboardData.items == undefined) {
        return;
      }
      if (
        (leaderboardData.hasOwnProperty("items") &&
          this.activityLeaderboardData.type == "bookings") ||
        this.activityLeaderboardData.type == "architecture" ||
        this.activityLeaderboardData.type == "enablement" ||
        this.activityLeaderboardData.type == "productBookingActivityChallenge"
      ) {
        this.leaderboardType = leaderboardData.type;
        this.entries = JSON.parse(JSON.stringify(leaderboardData.items));
      }
    }
  }

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    if (this.router.url.includes("manager")) {
      this.isManager = true;
    }
    if (
      this.userProfile &&
      this.userProfile.hasOwnProperty("userType") &&
      this.userProfile.userType == "PAM"
    ) {
      this.pamData = LocalService.get("pamData");
      const tblBeGeoIds = this.pamData.pamBeGeoIdsDTO ? this.pamData.pamBeGeoIdsDTO.beGeoIds : this.pamData.beGeoIds;
      const tblFirst = (tblBeGeoIds.content && tblBeGeoIds.content.length > 0) ? tblBeGeoIds.content[0] : (tblBeGeoIds.length > 0 ? tblBeGeoIds[0] : null);
      this.begeoid = tblFirst ? tblFirst.beGeoId : (this.userProfile.company ? this.userProfile.company.beGeoId : null);
    } else {
      this.begeoid =
        this.userProfile && this.userProfile.company
          ? this.userProfile.company.beGeoId
          : null;
    }
  }

  ngOnChanges() {
    this.userProfile = LocalService.get("userProfile");
    if (this.optOut === false || this.optOut === true) {
      if (this.activityLeaderboardData) {
        if (
          this.activityLeaderboardData.type === "productBookingActivityChallenge"
        ) {
          if (
            this.activityLeaderboardData.items &&
            this.activityLeaderboardData.items.length > 0
          ) {
            this.prodBookingData = this.activityLeaderboardData.items;
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    const ciscoLinkElement = document.head.querySelector(
      `link[rel="stylesheet"].${"cisco_styles"}`
    );
    if (ciscoLinkElement) {
      document.head.removeChild(ciscoLinkElement);
    }
  }
}
